import { get } from 'lodash';

import { COUNTRY, SPECIALTY } from 'common/constants';

import { STEP_KEY } from '../utils';

const mapCanadianInsurance = (data) => {
  let hasInsurance = get(data, `${[STEP_KEY.HAS_INSURANCE]}.data.id`);
  const insuranceDetails = get(data, `${[STEP_KEY.INSURANCE]}.data`);
  const socialAssistance = get(data, `${[STEP_KEY.SOCIAL_ASSISTANCE]}.data`);

  const provider = get(insuranceDetails, 'insurance');
  const insurance = {};

  if (hasInsurance === 'Yes' && provider !== 'Other') {
    insurance.hasInsurance = hasInsurance;
    insurance.provider = provider;
    insurance.topProvider = get(insuranceDetails, 'topProvider');
    insurance.socialAssistance = false;
  } else {
    hasInsurance = 'No'; // This might be "Yes" if "Other" insurance option is used
    insurance.hasInsurance = hasInsurance;
  }

  if (socialAssistance) {
    insurance.socialAssistance = socialAssistance.data;
  }

  return {
    hasInsurance,
    insurance,
    // "insurancePlan" is only provided for American patients
  };
};

const mapAmericanInsurance = (data) => {
  const hasInsurance = get(data, `${[STEP_KEY.HAS_INSURANCE]}.data.id`);
  const insuranceDetails = get(data, `${[STEP_KEY.INSURANCE]}.data`);
  const socialAssistance = get(data, `${[STEP_KEY.SOCIAL_ASSISTANCE]}.data`);

  const insurancePlan = get(insuranceDetails, 'data.plan.name');
  const insurance = {
    hasInsurance,
  };

  if (hasInsurance === 'Yes') {
    insurance.provider = get(insuranceDetails, 'provider.name');
    insurance.providerId = get(insuranceDetails, 'provider.id');
    insurance.plan = get(insuranceDetails, 'plan.name');
    insurance.planId = get(insuranceDetails, 'plan.id');
  }

  if (socialAssistance) {
    insurance.socialAssistance = socialAssistance.data;
  }

  return {
    hasInsurance,
    insurance,
    insurancePlan,
  };
};

export const mapToRequestBody = (user, data) => {
  const userId = get(user, 'id');
  const partnerId = get(user, 'partner.id');
  const location = get(data, `${[STEP_KEY.LOCATION]}.data`);
  const reason = get(data, `${[STEP_KEY.REASON]}.data.isUrgent`, '');

  let insuranceData = null;
  if (get(location, 'address.country') === COUNTRY.canada) {
    insuranceData = mapCanadianInsurance(data);
  } else if (get(location, 'address.country') === COUNTRY.unitedStates) {
    insuranceData = mapAmericanInsurance(data);
  }

  const result = {
    location,
    specialty: SPECIALTY,
    other: {
      hasInsurance: insuranceData.hasInsurance,
      insurance: insuranceData.insurance,
      location,
      userId,
      partnerId,
    },
  };

  const insurancePlan = get(insuranceData, 'insurancePlan');
  if (insurancePlan) {
    result.insurancePlan = insurancePlan;
  }

  if (reason.toLowerCase() === 'yes') {
    result.other.reason = 'Urgent Issue';
    result.other.reasonRaw = {
      overall: {
        name: 'Urgent Issue',
        id: 'urgent',
      },
    };
  }

  return result;
};
